/* global L */

const DISABLED_EVENTS = `
  mousewheel
  mousemove
  mousedrag
  touchmove
  touchdrag
  click
  mousedown
  touch
  touchstart
  dblclick
`;

export default function disableLeafletMouseEvents(element) {
  if (!element) return;

  L.DomEvent.off(
    element,
    DISABLED_EVENTS,
    L.DomEvent.stopPropagation
  );
}
